exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */\n@media print {\n  body * {\n    visibility: hidden;\n  }\n  #app {\n    visibility: visible !important;\n  }\n  #printable {\n    position: fixed;\n    left: 0;\n    top: 0;\n  }\n  #printable, #printable * {\n    visibility: visible;\n  }\n}\n", ""]);


//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/sass-loader?outputStyle=expanded!/src/components/Base/Base.scss
// module id = 1173
// module chunks = 0